const CHIP_GAP_PX = 4;
const MIN_CHIP_WIDTH_PX = 44;
const OVERFLOW_CHIP_MIN_WIDTH_PX = 40;
const SUMMARY_CHIP_MIN_WIDTH_PX = 56;
export const MAX_ADAPTIVE_VISIBLE_CHIPS = 12;
const CHIP_LABEL_FONT = '600 12px system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", sans-serif';

let measureCanvas;

const measureTextWidth = (text, minWidth) => {
	const label = String(text ?? '');
	if (!label) return minWidth;
	if (typeof document === 'undefined') return Math.max(minWidth, 28 + label.length * 8);

	measureCanvas ??= document.createElement('canvas');
	const ctx = measureCanvas.getContext('2d');
	if (!ctx) return Math.max(minWidth, 28 + label.length * 8);

	ctx.font = CHIP_LABEL_FONT;
	return Math.max(minWidth, Math.ceil(ctx.measureText(label).width) + 16);
};

export const measureChipWidth = (label) => {
	const text = String(label ?? '');
	if (!text) return MIN_CHIP_WIDTH_PX;
	if (typeof document === 'undefined') return MIN_CHIP_WIDTH_PX;

	measureCanvas ??= document.createElement('canvas');
	const ctx = measureCanvas.getContext('2d');
	if (!ctx) return MIN_CHIP_WIDTH_PX;

	ctx.font = CHIP_LABEL_FONT;
	return Math.max(MIN_CHIP_WIDTH_PX, Math.ceil(ctx.measureText(text).width) + 28);
};

export const measureOverflowChipWidth = (overflowCount) => {
	const count = Math.max(0, Number(overflowCount) || 0);
	return measureTextWidth(`+${count} 项`, OVERFLOW_CHIP_MIN_WIDTH_PX);
};

export const measureSummaryChipWidth = (selectedCount) => {
	const count = Math.max(0, Number(selectedCount) || 0);
	return measureTextWidth(`已选 ${count} 项`, SUMMARY_CHIP_MIN_WIDTH_PX);
};

/** 根据值区域宽度估算可完整展示的 tag 数；装不下则 0（仅完整「+N项」） */
export const calcAdaptiveVisibleChipCount = (valueAreaWidth, selectedOptions = [], maxCap = MAX_ADAPTIVE_VISIBLE_CHIPS) => {
	const count = selectedOptions.length;
	if (count === 0) return 0;
	if (!valueAreaWidth || valueAreaWidth <= 0) return 0;

	const limit = Math.min(count, maxCap);
	const chipWidths = selectedOptions.slice(0, limit).map((option) => measureChipWidth(option.label));

	for (let visible = limit; visible >= 1; visible -= 1) {
		const overflowCount = count - visible;
		let used = 0;
		for (let index = 0; index < visible; index += 1) {
			used += chipWidths[index] + CHIP_GAP_PX;
		}
		used -= CHIP_GAP_PX;
		if (overflowCount > 0) {
			used += CHIP_GAP_PX + measureOverflowChipWidth(overflowCount);
		}
		if (used <= valueAreaWidth) return visible;
	}

	// 一枚芯片都放不下：能放下完整「+N项」则只显示计数，否则也不半截芯片
	if (measureOverflowChipWidth(count) <= valueAreaWidth) return 0;
	return 0;
};

/**
 * 窄控件优先摘要 Chip「已选 N 项」；仅当全部标签都能放下时展示标签 Chip。
 * @returns {{ mode: 'empty' | 'chips' | 'summary', visible: number }}
 */
export const resolveChipDisplayMode = (valueAreaWidth, selectedOptions = [], maxCap = MAX_ADAPTIVE_VISIBLE_CHIPS) => {
	const count = selectedOptions.length;
	if (count === 0) return { mode: 'empty', visible: 0 };

	const visible = calcAdaptiveVisibleChipCount(valueAreaWidth, selectedOptions, maxCap);
	if (visible >= count) {
		return { mode: 'chips', visible };
	}

	const summaryWidth = measureSummaryChipWidth(count);
	if (!valueAreaWidth || valueAreaWidth <= 0 || summaryWidth <= valueAreaWidth || visible === 0) {
		return { mode: 'summary', visible: 0 };
	}

	// 摘要也略挤时：仍优先摘要（可读性 > 半截标签）
	return { mode: 'summary', visible: 0 };
};
